import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { ReportesService } from 'app/services/reportes/reportes.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-det-comprobante-electronico',
  templateUrl: './det-comprobante-electronico.component.html',
  styleUrls: ['./det-comprobante-electronico.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesStatus]
})
export class DetComprobanteElectronicoComponent{

  @Output() cerrarPopDetalleComprobante: EventEmitter<boolean> = new EventEmitter();

  idDesembolso: any;
  dataReporte: any = [];
  isLoading: boolean = true;
  dataSource: any;

  @ViewChild('TABLE', { static: true }) table: ElementRef;
  displayedColumns: string[] = ['Adelanto_importe', 'Interes_importe', 'Comision_importe', 'IGV_importe', 'Factoring_Importe', 'Factoring_SUNAT_importe']

  constructor(private reporteService: ReportesService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {
    this.idDesembolso = this.reporteService.idDesembolso;
    this.obtenerDetalleCompE();
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataReporte);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    let fecha = new Date();
    XLSX.writeFile(wb, 'Detalle_Comprobante' + fecha + '.xlsx');
  }

  obtenerDetalleCompE() {
    this.reporteService.FiltrarDetallePlanilla(this.idDesembolso)
      .subscribe(res => {
        this.dataReporte = res;
        this.isLoading = false;
        this.dataSource = new MatTableDataSource(this.dataReporte)
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA DETALLE COMPROBANTE. NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  CerrarPopUp() {
    this.cerrarPopDetalleComprobante.emit();
  }
}
